/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Carrier_Notices_Characters_RemainingInputs */

const en_carrier_notices_characters_remaining = /** @type {(inputs: Carrier_Notices_Characters_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} characters remaining`)
};

const es_carrier_notices_characters_remaining = /** @type {(inputs: Carrier_Notices_Characters_RemainingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} caracteres restantes`)
};

/**
* | output |
* | --- |
* | "{count} characters remaining" |
*
* @param {Carrier_Notices_Characters_RemainingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const carrier_notices_characters_remaining = /** @type {((inputs: Carrier_Notices_Characters_RemainingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Notices_Characters_RemainingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_carrier_notices_characters_remaining(inputs)
	return es_carrier_notices_characters_remaining(inputs)
});